import { apiPath } from "../../constants";
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const RANKS_REQUEST = 'FETCH_RANKS_REQUEST';
export const RANKS_FAILURE = 'FETCH_RANKS_FAILURE';
export const RANKS_SUCCESS = 'FETCH_RANKS_SUCCESS';

export const fetchRanks = () => {
    return function(dispatch) {
        dispatch(fetchRanksRequest());
        return axios(apiRequestOptions(apiPath.RANKS.LIST))
            .then(transformHttpResponse)
            .then(response => dispatch(fetchRanksSuccess(response.data)))
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(fetchRanksFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const fetchRanksRequest = () => {
    return {
        type: RANKS_REQUEST,
    }
};

const fetchRanksFailure = (error) => {
    return {
        type: RANKS_FAILURE,
        error,
    }
};

const fetchRanksSuccess = (data) => {
    return {
        type: RANKS_SUCCESS,
        data,
    }
};